import React, { useState, useEffect } from "react";
import { Analytics } from '@vercel/analytics/react';
import Header from "./Header";
import Footer from "./Footer";
import { preloadAuthToken } from "../../utils/authHelper";

export default function Layout({ children }) {
  const [cookiesAccepted, setCookiesAccepted] = useState(new Set());
  const [consentId, setConsentId] = useState(null);
  const [isAuthInitialized, setIsAuthInitialized] = useState(false);

  useEffect(() => {
    const handleConsent = ({ detail }) => {
      setCookiesAccepted(new Set(detail.cookie.categories));
      setConsentId(detail.cookie.consentId);
    };

    window.addEventListener('cc:onConsent', handleConsent);

    return () => {
      window.removeEventListener('cc:onConsent', handleConsent);
    };
  }, []);

  useEffect(() => {
    // Initialize authentication state
    const initAuth = async () => {
      await preloadAuthToken();
      setIsAuthInitialized(true);
    };
    
    initAuth();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    console.log("[Cookies] Consent ID:", consentId); 
  }, []); // Empty dependency array

  useEffect(() => {
    if (cookiesAccepted.has('analytics')) {
      // Microsoft Clarity Tag
      (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "qr7vzfpqkh");
  
      // Google Tag (gtag.js)
      const gtagScript = document.createElement('script');
      gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=G-Q39XE9LEVT";
      gtagScript.async = true;
      document.head.appendChild(gtagScript);
  
      gtagScript.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag(){window && window.dataLayer && window.dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-Q39XE9LEVT');
      };
    }
  }, [cookiesAccepted]);

  if (!isAuthInitialized) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-12 h-12 border-4 border-gray-200 border-t-[#406580] rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen bg-white"> {/* Added bg-white to the main div */}
      <Header />
      <main className="flex-grow"> {/* Removed bg-[#1f2127] from main */}
        {children}
      </main>
      {cookiesAccepted.has('analytics') && <Analytics />}
      <Footer />
    </div>
  );
}
